import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EliteHeader from "@/components/ui/elite-header";
import GazealEliteHero from "@/components/ui/ethereal-beams-hero";
import FeaturesBento from "@/components/ui/features-bento";
import AdvanceSection from "@/components/ui/advance-section";
import FallsThroughSection from "@/components/ui/falls-through-section";
import EliteTestimonials from "@/components/ui/elite-testimonials";
import EliteFAQ from "@/components/ui/elite-faq";
import EliteFooterReveal from "@/components/ui/elite-footer-reveal";

const EliteLanding = ({ variant }) =>
  <div className="App min-h-screen bg-black">
    <EliteHeader />
    <main className="relative z-10 bg-black">
      <GazealEliteHero variant={variant} />
      <FeaturesBento />
      <AdvanceSection />
      <FallsThroughSection />
      <EliteTestimonials />
      <EliteFAQ />
    </main>
    <EliteFooterReveal />
  </div>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<EliteLanding variant="default" />} />
        <Route path="/fc" element={<EliteLanding variant="fine-and-country" />} />
        <Route path="/fine-and-country" element={<EliteLanding variant="fine-and-country" />} />
      </Routes>
    </BrowserRouter>);
}

export default App;
